import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Partner} from '../../../../../../models/partner/partner';
import {SnackbarService} from '../../../../../../services/snackbar/snackbar.service';
import {DialogService} from '../../../../../../services/dialog/dialog.service';
import {PartnerBlockRule} from '../../../../../../models/partner/partner-block-rule';
import {PartnerBlockRuleService} from '../../../../../../services/partner/partner-block-rule.service';
import {BlockRuleFormComponent} from '../block-rule-form/block-rule-form.component';

import {ConfirmDirective} from '../../../../../../directives/confirm/confirm.directive';
import {CopyToClipboardComponent} from '../../../../../layout/copy-to-clipboard/copy-to-clipboard.component';

@Component({
  selector: 'app-block-rule-list',
  imports: [
    ConfirmDirective,
    CopyToClipboardComponent
],
  templateUrl: './block-rule-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './block-rule-list.component.scss'
})
export class BlockRuleListComponent implements OnInit {

  @Input() partner: Partner | null = null;

  rules: PartnerBlockRule[] = [];
  loaded: boolean = false;

  constructor(
    private blockRuleService: PartnerBlockRuleService,
    private snackbar: SnackbarService,
    private dialog: DialogService
  ) {
  }

  ngOnInit(): void {
    this.fetchAll();
  }

  fetchAll(): void {
    if (this.partner) {
      this.blockRuleService.findAll({partnerId: this.partner.id}).subscribe((rules: PartnerBlockRule[]) => {
        this.rules = rules;
        this.loaded = true;
      });
    }
  }

  openForm(blockRule: PartnerBlockRule | null = null): void {
    this.dialog.openDialog(BlockRuleFormComponent, {
      data: {
        partner: this.partner,
        blockRule,
      }
    }).subscribe((result) => {
      if (result) {
        this.fetchAll();
      }
    });
  }

  deleteRule(blockRule: PartnerBlockRule): void {
    if (blockRule.id) {
      this.blockRuleService.delete(blockRule.id).subscribe(() => {
        this.fetchAll();

        this.snackbar.success('The block rule has been deleted.');
      });
    }
  }

}
